module.exports = __webpack_public_path__ + "static/media/eye-icon.9884c0c0.svg";